export const buildCategoryChartCacheKey = (key: string) =>
  `categoryChart.${key}`
